import React, { createContext, useCallback, useState } from "react";

export const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState(null);
  const timeoutRef = React.useRef(null);

  const openToast = useCallback((message, duration = 5000, type = "info") => {
    // Clear existing timeout if any
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    // Set new toast
    setToast({ message, type });

    // Auto remove toast after duration
    timeoutRef.current = setTimeout(() => {
      setToast(null);
      timeoutRef.current = null;
    }, duration);

    // Return function to manually close toast
    return () => {
      clearTimeout(timeoutRef.current);
      setToast(null);
      timeoutRef.current = null;
    };
  }, []);

  const value = {
    toast,
    openToast,
    removeToast: () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      setToast(null);
    }
  };

  return (
    <ToastContext.Provider value={value}>
      {children}
    </ToastContext.Provider>
  );
};
